const easings = {
  in: 'cubic-bezier(0, 1, 0.1, 1)',
  out: 'cubic-bezier(0.86, 0, 1, 0.23)',
};

export default easings;
